import React from 'react'
import styled, { css } from 'styled-components/macro'
import {
  ButtonGroup,
  Filter,
  FilterButton,
  FilterButtonIcon,
} from 'src/components/Reusable/Buttons/SwitchButton/SwitchButton.styles'

// Small sits in a row of 28px icon buttons.
const SmallFilter = styled(Filter)`
  height: 28px;
`

const FilterTabButton = styled(FilterButton)<{ $small?: boolean }>`
  padding-left: 20px;
  padding-right: 20px;
  ${({ $small }) =>
    $small &&
    css`
      &&,
      &&.active-tab {
        gap: 4px;
        padding: 4px 12px;
        font-size: 12px;
      }
      .filter-button-icon {
        width: 12px;
        height: 12px;
      }
    `}
`

export const FilterTabs = <T extends string>({
  onSelect,
  currentSelected,
  options,
  customLabels,
  size,
}: {
  onSelect: (tab: T) => void
  currentSelected: T
  options: T[]
  customLabels?: Record<T, JSX.Element>
  size?: 'small'
}): JSX.Element => {
  const getButtonClass = (isSelected: boolean) => {
    return isSelected ? 'active-tab' : ''
  }
  const small = size === 'small'
  const Tabs = small ? SmallFilter : Filter

  return (
    <ButtonGroup>
      <Tabs $numItems={3}>
        {Object.values(options).map((tab) => (
          <FilterTabButton
            key={tab}
            onClick={() => onSelect(tab)}
            className={getButtonClass(currentSelected === tab)}
            $small={small}
          >
            {currentSelected === tab && <FilterButtonIcon />}
            <span>{customLabels?.[tab] || tab}</span>
          </FilterTabButton>
        ))}
      </Tabs>
    </ButtonGroup>
  )
}
